import { useDispatch } from "react-redux"
import Btn from "../../shared/button/Btn"
import { closeAllModal } from "../../../features/modal/modalSlice"
import { useSelector } from "react-redux"
import { setSelectedRouteItem, updateRouteItem } from "../../../features/addLoad/addLoadSlice"
import styled from "styled-components"
import locationData from "../../../utils/locationData/locationOptions"
import addLoadLocationData from "../../../utils/locationData/addLoadLocationOptions"
import { setAdresAutoComplete } from "../../../features/address/addressSlice"



const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .desc{
            height: auto;
            display: flex;
            padding: 10px 40px;
            width: 100%;
            text-align: center;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);

        }

        .btn-container{
            width: 100%;
            padding: 20px;
            padding-bottom: 30px;
            display: flex;
            justify-content: center;
            gap: 40px;
        }
    }
`

const AddLoadRouteItemNotSavedDescModal = () => {

    const dispatch = useDispatch()
    const {selectedRouteItem, route} = useSelector(state => state.addLoad) 

    const handleSubmit = () => {

        //! route içinden ilgili routeItem 
        const currentItem = route.find(item => item.id === selectedRouteItem.id)
  
        const locationItem = addLoadLocationData.find(item => {
          return selectedRouteItem?.locationData?.googleLocation?.includes(item.city) && selectedRouteItem?.locationData?.googleLocation?.includes(item.town)
        })
  
  
        dispatch(updateRouteItem({...selectedRouteItem,
          adres: currentItem?.adres ? currentItem?.adres : selectedRouteItem?.locationData?.googleLocation, 
          locationData: {
          ...selectedRouteItem?.locationData,
          il: currentItem?.locationData?.location ? currentItem.locationItem?.il : locationItem?.city,
          ilId: currentItem?.locationData?.ilId ? currentItem?.locationData?.ilId : locationItem?.cityId,
          ilce: currentItem?.locationData?.ilce ? currentItem?.locationData?.ilce : locationItem?.town,
          ilceId: currentItem?.locationData?.ilceId ? currentItem?.locationData?.ilceId : locationItem?.townId,
          bolge: currentItem?.locationData?.bolge ? currentItem?.locationData?.bolge : locationItem?.region,
          location: currentItem?.locationData?.location ? currentItem?.locationData?.location : locationItem?.location,
  
  
          lat: selectedRouteItem?.locationData?.googleLat,
          lng: selectedRouteItem?.locationData?.googleLng,
          googleLat: selectedRouteItem?.locationData?.googleLat,
          googleLng: selectedRouteItem?.locationData?.googleLng,
        }}));
  
        dispatch(closeAllModal(null))
        dispatch(setSelectedRouteItem(null))
        dispatch(setAdresAutoComplete([]))

      } 


  return (
    <Container>
        <div className="modal">
            <p className="desc">Tam Konum bilgisini kaydetmediniz, sorunsuz sevkiyat işlemi ve sefer konum takibi için tam konum bilgisini girmeniz önerilir.</p>
            <div className="btn-container">
                <Btn bgColor="#E85446" color="#fff" width={"240px"} handleClick={handleSubmit}>Değişiklikleri kaydet</Btn>
                <Btn bgColor="#fff" color="#E85446" fontWeight="700" width={"240px"} fo handleClick={() => dispatch(closeAllModal())}>Tam Konum verilerini kullanma</Btn>
            </div>

        </div>
        
    </Container>
  )
}

export default AddLoadRouteItemNotSavedDescModal